import { render, staticRenderFns } from "./ReportAndDispose.vue?vue&type=template&id=03806260&scoped=true&"
import script from "./ReportAndDispose.vue?vue&type=script&lang=js&"
export * from "./ReportAndDispose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03806260",
  null
  
)

export default component.exports